<template>
  <div v-loading="loading">
    <el-form
      label-width="80px"
      @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="交易时间:">
            <date-range-select
              v-model="daterange"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单来源:">
            <order-source-select
              v-model="config.source"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收件人:">
            <el-input
              v-model.trim="config.receiverName"
              clearable=""
              placeholder="请输入收件人姓名">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单号:">
            <el-input
              v-model.trim="config.code"
              clearable=""
              placeholder="请输入订单号">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="销售部门:">
            <el-input
              v-model.trim="config.saleDepartmentName"
              clearable=""
              placeholder="请输入销售部门">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="销售人员:">
            <el-input
              v-model.trim="config.saleStaffName"
              clearable=""
              placeholder="请输入销售人员">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发货状态:">
            <status-select
              v-model="config.outStatus"
              style="width: 100%"
              :exclude="[2,9]"
              :callback="()=> { handleCurrentChange(1) }" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注:">
            <el-input
              v-model.trim="config.remark"
              clearable=""
              placeholder="请输入备注">
            </el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="发货方式:">
            <el-radio-group
              v-model="config.outTypeList"
              @change="()=> {handleCurrentChange(1)}">
              <el-radio-button :label="[1, 2]">全部</el-radio-button>
              <el-radio-button :label="[1]">正常发货</el-radio-button>
              <el-radio-button :label="[2]">空包</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="发货方式:">
            <out-type-select-new
              v-model="config.outTypeNew"
              :exclude="['0-']"
              :callback="()=>handleCurrentChange(1)" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="">
            <el-button
              type="primary"
              @click="handleCurrentChange(1)">查询</el-button>

            <!-- <el-dropdown>
              <el-button
                style="margin-left:10px"
                type="success"
                :disabled="multipleSelection.length === 0">批量出库<span v-if="multipleSelection.length > 0">(共{{ multipleSelection.length }}项)</span></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="batchOut(true)">按收件人合并</el-dropdown-item>
                <el-dropdown-item @click.native="batchOut(false)">不合并</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <batch-out-order-btn
              :disabled="multipleSelection.length === 0"
              :showCount="multipleSelection.length > 0"
              :selection="multipleSelection"
              :callback="fetchList"
              @toggleLoading="toggleLoading" />
            <no-pager-checkbox
              v-model="noPager"
              :pagerNo="pagerNo"
              :pagerYes="pagerYes"
              style="margin-left: 5px" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      ref="table"
      border
      :data="list"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        fixed="left"
        :selectable="(row)=> row.outNum < row.planNum"
        :resizable="false"
        width="40">
      </el-table-column>
      <el-table-column
        label="订单号"
        fixed="left"
        :resizable="false"
        width="170">
        <template slot-scope="{row}">
          <link-route :link-to="`/orders-detail?vendorId=${row.parentOwnerCode}&salesOrderId=${row.id}&code=${row.code}`">
            {{ row.code }}
          </link-route>
        </template>
      </el-table-column>
      <el-table-column
        label="收件人"
        min-width="200"
        :resizable="false">
        <template slot-scope="{row}">
          <div>
            <span v-if="row.customerName">{{ row.customerName }}-</span>
            <span>{{ row.receiverName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="订单金额"
        width="100"
        :resizable="false">
        <template slot-scope="{row}">
          <div>¥{{ row.totalAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="订单来源"
        width="100"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.source | sourceName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="订单状态"
        width="90"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.status | orderStatusName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="发货状态"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.outStatus | orderOutStatusName() }}
        </template>
      </el-table-column>
      <el-table-column
        label="发货方式"
        width="90"
        :resizable="false">
        <template slot-scope="{row}">
          <!-- {{ row.outType | orderOutTypeName() }} <span v-if="row.orderFlag && row.orderFlag!=='0'">({{ row.orderFlag | orderTagName() }})</span> -->
          <span v-if="row.outType === 0">待定</span>
          <span v-if="row.outType === 1 && row.orderFlag === '1'">正常发货</span>
          <span v-if="row.outType === 1 && row.orderFlag === '2'">改单发货</span>
          <span v-if="row.outType === 2 && row.orderFlag === '3'">空包发货</span>
          <span v-if="row.outType === 1 && row.orderFlag === '3'">刷单发货</span>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        min-width="180"
        prop="remark"
        :resizable="false">
      </el-table-column>
      <el-table-column
        label="交易时间"
        :resizable="false"
        width="140">
        <template slot-scope="{row}">
          {{ row.tradeTime | dateformat( ) }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        :resizable="false"
        width="175">
        <template slot-scope="{row}">
          <!-- <template v-if="[0, 1].indexOf(row.status) > -1"> -->
          <el-button
            type="success"
            :disabled="!(row.outNum < row.planNum)"
            @click.native="addout(row)">建单</el-button>
          <el-dropdown>
            <el-button
              type="info"
              style="margin-left: 10px">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item
                :disabled="!(row.outNum < row.planNum)"
                @click.native="addout(row)">建单</el-dropdown-item> -->
              <el-dropdown-item
                :disabled="!(row.outStatus === 0)"
                @click.native="deaudit(row)">反审</el-dropdown-item>
              <el-dropdown-item
                :disabled="!(row.source === 9 && row.outStatus === 0)"
                @click.native="salescancel(row)">删除</el-dropdown-item>
              <el-dropdown-item
                @click.native="salesfinish(row, false)">强制关闭</el-dropdown-item>
              <el-dropdown-item
                @click.native="salesfinish(row, true)">无码出库</el-dropdown-item>
              <el-dropdown-item
                @click.native="editremark(row)">修改备注</el-dropdown-item>
              <!-- :disabled="!(row.source === 9 && row.outStatus > 0)" -->
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button
              v-if="row.outNum < row.planNum"
              type="primary"
              @click.native="addout(row)">
              建单
            </el-button>
            <el-button
              v-if="row.outStatus === 0"
              type="warning"
              @click.native="deaudit(row)">
              反审
            </el-button>
            <el-button
              v-if="row.source === 9 && row.outStatus === 0"
              type="danger"
              @click.native="salescancel(row)">
              删除
            </el-button>
            <el-button
              v-if="row.source === 9 && row.outStatus > 0"
              type="info"
              @click.native="salesfinish(row)">
              强制关闭
            </el-button> -->
          <!-- </template> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-if="!noPager"
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <order-out-modal
      ref="out"
      :callback="fetchList" />
    <order-extra-modal ref="extra" />

    <order-remark-modal
      ref="remark"
      :callback="fetchList" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OrderOutModal from './busi/order-out-modal.vue'
import NP from 'number-precision'
import OrderExtraModal from './busi/order-extra-modal.vue'
import OrderSourceSelect from './order-source-select.vue'
import DateRangeSelect from './date-range-select.vue'
import moment from 'moment'
import NoPagerCheckbox from '../../components/no-pager-checkbox.vue'
import OutTypeSelectNew from './out-type-select-new.vue'
import StatusSelect from './status-select.vue'
import OrderRemarkModal from './busi/order-remark-modal.vue'
import BatchOutOrderBtn from '../../components/batch-out-order-btn.vue'

export default {
  name: 'OrderTable',
  components: { BatchOutOrderBtn, OrderRemarkModal, StatusSelect, OrderOutModal, OrderExtraModal, OutTypeSelectNew, OrderSourceSelect, DateRangeSelect, NoPagerCheckbox },
  props: {
    // outType: {
    //   type: Number,
    //   default: -1
    // }
  },
  data() {
    return {
      loading: false,
      noPager: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        code: '',
        statusList: [0, 1],
        outTypeNew: null,
        receiverName: '',
        outTypeList: [1, 2],
        outStatusList: [0, 1],
        saleDepartmentName: null,
        saleStaffName: null,
        outStatus: null,
        remark: ''
      },
      daterange: null,
      list: [],
      multipleSelection: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    toggleLoading(loading) {
      this.loading = loading
    },
    editremark(row) {
      this.$refs.remark.fetch({
        salesOrderId: row.id,
        remark: row.remark,
        code: row.code
      })
    },
    pagerNo() {
      this.config.pageSize = 1000000
      this.handleCurrentChange(1)
    },
    pagerYes() {
      this.config.pageSize = 10
      this.handleCurrentChange(1)
    },
    salescancel(row) {
      this.$confirm('此操作将撤销该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/salescancel', {
            payload: {
              code: row.code
            },
            success: () => {
              this.loading = false
              // this.$refs.table.clearSelection()
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    deaudit(row) {
      this.$confirm('此操作将回退该订单到重新审核状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/deaudit', {
            payload: {
              salesOrderId: row.id
            },
            success: () => {
              this.loading = false
              // this.$refs.table.clearSelection()
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    salesfinish(row, forcedDelivery) {
      this.$confirm(`此操作将对该订单进行${forcedDelivery ? '无码出库' : '强制关闭'}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/salesfinish', {
            payload: {
              code: row.code,
              forcedDelivery
            },
            success: () => {
              this.loading = false
              // this.$refs.table.clearSelection()
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    addout(row) {
      this.$refs.out.fetch(row.id)
    },
    addextraout(row) {
      this.$refs.extra.fetch(row.id)
    },
    hascombineddelivery() {
      this.loading = true
      this.$store.dispatch('outstock/hascombineddelivery', {
        payload: {
          salesOrderIdList: this.multipleSelection.map(i => i.id)
        },
        success: (res) => {
          this.loading = false
          console.log(res)
          // if (res.data.data && res.data.data.length > 0) {}
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    batchOut(combinedDelivery) {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先勾选订单')
        return
      }
      this.$confirm('此操作将对选中的订单进行批量创建出库单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('outstock/addbysalesorder', {
          payload: {
            combinedDelivery,
            salesOrderIdList: this.multipleSelection.map(i => i.id)
          },
          success: (res) => {
            this.loading = false
            console.log(res)
            if (res.data.data && res.data.data.length > 0) {
              this.$alert(`批量建单请求订单数为${this.multipleSelection.length}单，其中${res.data.data.length}单由于库存不足建单失败！`, '提示', {
                confirmButtonText: '确定'
              })
            }
            // this.$refs.table.clearSelection()
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      // this.$refs.table.clearSelection()
      this.loading = true
      const [tradeTimeStart, tradeTimeEnd] = this.daterange || [null, null]
      const [outType, orderFlag] = (this.config.outTypeNew || '-').split('-')
      this.$store.dispatch('outstock/getsaleslist', {
        payload: {
          ...this.config,
          outType: outType || null,
          orderFlag: orderFlag || null,
          receiverName: this.config.receiverName || null,
          tradeTimeStart: +moment(tradeTimeStart).startOf('days'),
          tradeTimeEnd: +moment(tradeTimeEnd).endOf('days')
          // outType: this.outType === -1 ? null : this.outType
        },
        success: (res) => {
          this.loading = false
          const data = res.data.data
          this.list = data.records
            // .filter(i => i.outNum < i.planNum && [0, 1].indexOf(i.status) > -1)
            .map(i => ({
              ...i,
              totalAmount: NP.divide(i.totalAmount, 100),
              itemAmount: NP.divide(i.itemAmount, 100),
              discountAmount: NP.divide(i.discountAmount, 100)
            }))
          this.total = data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
